import type { WorkspaceRole } from "./types";

export type WorkspaceCapability =
  | "createProject"
  | "configureProject"
  | "publishRuntime"
  | "viewConversations"
  | "viewInsights"
  | "manageMembers"
  | "viewBilling"
  | "manageBilling";

const CAPABILITIES: Record<WorkspaceRole, ReadonlySet<WorkspaceCapability>> = {
  owner: new Set([
    "createProject",
    "configureProject",
    "publishRuntime",
    "viewConversations",
    "viewInsights",
    "manageMembers",
    "viewBilling",
    "manageBilling",
  ]),
  admin: new Set([
    "createProject",
    "configureProject",
    "publishRuntime",
    "viewConversations",
    "viewInsights",
    "manageMembers",
    "viewBilling",
    "manageBilling",
  ]),
  editor: new Set(["configureProject", "viewConversations", "viewInsights"]),
  analyst: new Set(["viewConversations", "viewInsights"]),
  billing: new Set(["viewBilling", "manageBilling"]),
  viewer: new Set(),
};

export function roleCan(
  role: WorkspaceRole | null | undefined,
  capability: WorkspaceCapability,
): boolean {
  return role ? CAPABILITIES[role].has(capability) : false;
}

export function roleLabel(role: WorkspaceRole): string {
  return {
    owner: "Proprietário",
    admin: "Administrador",
    editor: "Editor",
    analyst: "Analista",
    billing: "Financeiro",
    viewer: "Visualizador",
  }[role];
}
